module.exports = __webpack_public_path__ + "static/media/minimize.c223c89f.svg";